import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_CATEGORY_LIST_REQUEST = 'FETCH_CATEGORY_LIST_REQUEST';
export const FETCH_CATEGORY_LIST_SUCCESS = 'FETCH_CATEGORY_LIST_SUCCESS';
export const FETCH_CATEGORY_LIST_FAILURE = 'FETCH_CATEGORY_LIST_FAILURE';

export const CREATE_CATEGORY_REQUEST = 'CREATE_CATEGORY_REQUEST';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE';

export const FETCH_CRM_CATEGORY_REQUEST = 'FETCH_CRM_CATEGORY_REQUEST';
export const FETCH_CRM_CATEGORY_SUCCESS = 'FETCH_CRM_CATEGORY_SUCCESS';
export const FETCH_CRM_CATEGORY_FAILURE = 'FETCH_CRM_CATEGORY_FAILURE';

export const EDIT_CRM_CATEGORY_REQUEST = 'EDIT_CRM_CATEGORY_REQUEST';
export const EDIT_CRM_CATEGORY_SUCCESS = 'EDIT_CRM_CATEGORY_SUCCESS';
export const EDIT_CRM_CATEGORY_FAILURE = 'EDIT_CRM_CATEGORY_FAILURE';

export const EDIT_CATEGORY_SEQUENCE_REQUEST = 'EDIT_CATEGORY_SEQUENCE_REQUEST';
export const EDIT_CATEGORY_SEQUENCE_SUCCESS = 'EDIT_CATEGORY_SEQUENCE_SUCCESS';
export const EDIT_CATEGORY_SEQUENCE_FAILURE = 'EDIT_CATEGORY_SEQUENCE_FAILURE';

export const GET_DEFAULT_RESOLUTION_TIME_REQUEST = 'GET_DEFAULT_RESOLUTION_TIME_REQUEST';
export const GET_DEFAULT_RESOLUTION_TIME_SUCCESS = 'GET_DEFAULT_RESOLUTION_TIME_SUCCESS';
export const GET_DEFAULT_RESOLUTION_TIME_FAILURE = 'GET_DEFAULT_RESOLUTION_TIME_FAILURE';

export const EDIT_DEFAULT_RESOLUTION_TIME_REQUEST = 'EDIT_DEFAULT_RESOLUTION_TIME_REQUEST';
export const EDIT_DEFAULT_RESOLUTION_TIME_SUCCESS = 'EDIT_DEFAULT_RESOLUTION_TIME_SUCCESS';
export const EDIT_DEFAULT_RESOLUTION_TIME_FAILURE = 'EDIT_DEFAULT_RESOLUTION_TIME_FAILURE';

export const FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_REQUEST = 'FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_REQUEST';
export const FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_SUCCESS = 'FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_SUCCESS';
export const FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_FAILURE = 'FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_FAILURE';

const baseURL = 'agencies/crm/categories';
const defaultResolveByDaysURL = 'agencies/crm/config/resolve-by-days';

export const createCategory = (crmCategoryRequest: ICRMCategoryRequest) => {
  const newCrmCategoryRequest = {
    ...crmCategoryRequest,
    fields: [{ fields: crmCategoryRequest.field, isActive: crmCategoryRequest.isActive }],
    internalCustomFields: [{ fields: crmCategoryRequest.internalCustomFields, isActive: crmCategoryRequest.isActive }],
  };
  delete newCrmCategoryRequest.field;

  return {
    [CALL_API]: {
      endpoint: baseURL,
      method: 'post',
      body: newCrmCategoryRequest,
      authenticated: true,
      types: [CREATE_CATEGORY_REQUEST, CREATE_CATEGORY_SUCCESS, CREATE_CATEGORY_FAILURE],
    },
  };
};

export const fetchCategoryList = (params?: CategoryListParams) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    params,
    authenticated: true,
    types: [FETCH_CATEGORY_LIST_REQUEST, FETCH_CATEGORY_LIST_SUCCESS, FETCH_CATEGORY_LIST_FAILURE],
  },
});

export const fetchCategoryById = (categoryId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${categoryId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_CRM_CATEGORY_REQUEST, FETCH_CRM_CATEGORY_SUCCESS, FETCH_CRM_CATEGORY_FAILURE],
  },
});

export const editCategory = (categoryId: number, categoryData: ICRMCategoryRequest) => {
  const newCategoryData = {
    ...categoryData,
    fields: [{ fields: categoryData.field, isActive: categoryData.isActive, _id: categoryData.fieldId }],
    internalCustomFields: [
      { fields: categoryData.internalCustomFields, isActive: categoryData.isActive, _id: categoryData.fieldId },
    ],
  };
  delete newCategoryData.field;

  return {
    [CALL_API]: {
      endpoint: `${baseURL}/${categoryId}`,
      method: 'put',
      authenticated: true,
      body: newCategoryData,
      types: [EDIT_CRM_CATEGORY_REQUEST, EDIT_CRM_CATEGORY_SUCCESS, EDIT_CRM_CATEGORY_FAILURE],
    },
  };
};

export const editCategorySequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    types: [EDIT_CATEGORY_SEQUENCE_REQUEST, EDIT_CATEGORY_SEQUENCE_SUCCESS, EDIT_CATEGORY_SEQUENCE_FAILURE],
  },
});

export const getResolveByDays = () => ({
  [CALL_API]: {
    endpoint: defaultResolveByDaysURL,
    method: 'get',
    authenticated: true,
    types: [
      GET_DEFAULT_RESOLUTION_TIME_REQUEST,
      GET_DEFAULT_RESOLUTION_TIME_SUCCESS,
      GET_DEFAULT_RESOLUTION_TIME_FAILURE,
    ],
  },
});

export const editResolveByDays = (resolveByDays: number) => ({
  [CALL_API]: {
    endpoint: defaultResolveByDaysURL,
    method: 'put',
    authenticated: true,
    body: { resolveByDays },
    types: [
      EDIT_DEFAULT_RESOLUTION_TIME_REQUEST,
      EDIT_DEFAULT_RESOLUTION_TIME_SUCCESS,
      EDIT_DEFAULT_RESOLUTION_TIME_FAILURE,
    ],
  },
});

export const fetchExternalIntegrationCategoryList = (params?: CategoryListParams) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    params,
    authenticated: true,
    types: [
      FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_REQUEST,
      FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_SUCCESS,
      FETCH_EXTERNAL_INTEGRATION_CATEGORY_LIST_FAILURE,
    ],
  },
});
